import {postService} from "@/@@@dj-framework/libs/service/DjNetwork";
// export const baseUrl = 'http://apis.kfwebclub.com/';
// export const baseUrl = 'http://api.dhjk.kfwebclub.com/';
export const baseUrl = 'https://api.dhjk.cn/';

export default function dj_postRequest(url,parameter={}){
    return postService(baseUrl+url,parameter)
}
